import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Router } from '@angular/router'
import { finalize } from 'rxjs/operators'

import { ResultCode } from '../../../domain/authentication.model'
import { AuthService } from '../../../services/auth.service'
import { NotificationService } from '../../../services/notification.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-restore-password-form',
  templateUrl: './bmcore-restore-password-form.component.html',
  styleUrls: ['./bmcore-restore-password-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreRestorePasswordFormComponent implements OnInit {
  lg: LgType
  restorePasswordForm: UntypedFormGroup
  isLoader = false

  constructor(
    private i18nService: I18nService,
    private authService: AuthService,
    private router: Router,
    private notificationService: NotificationService,
    private formBuilder: UntypedFormBuilder
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()

    this.restorePasswordForm = this.formBuilder.group({
      email: []
    })
  }

  onSubmit() {
    if (this.restorePasswordForm.valid) {
      this.isLoader = true

      const { email } = this.restorePasswordForm.value.email

      this.authService
        .requestPasswordRecovery(email)
        .pipe(finalize(() => (this.isLoader = false)))
        .subscribe(
          res => {
            if (res.resultCode === ResultCode.Success) {
              // Если все ok, то user идет на почту и переходит по ссылке в письме,
              // которая ведет на NewPasswordPage component (считывается code из queryParams)
              // Пример ссылки: https://beatmakers.tv/new-password?code=4f4b1aa1-d7c2-4d84-9f74-a05c821d85ba
              this.router.navigate(['/check-email', { email, path: 'restorePassword' }])
            } else {
              this.notificationService.handleError(res.messages[0])
            }
          },
          err => this.notificationService.handleError(err.message)
        )
    } else {
      this.notificationService.handleError(this.lg.forms.error)
    }
  }
}
